(ns frontend.view.settings2.security.db
  (:require [reagent.core :as r]
            [frontend.db :as app-db]))

(def state (r/cursor app-db/app-state [:views :settings :security]))
(def state-atom (r/cursor state [:state-atom]))
(def exports (r/cursor app-db/app-state [:views :settings :exports]))
